import {createSelector} from 'reselect';

const getTranslations = (state) => {
    return state.translations;
};

/** @todo Put remaining hit translations here so that they are no longer pulled from the API response */
const getHitTranslations = createSelector(
    getTranslations,
    (translations) => {
        return {
            avgNight: translations['header.scratchpadSummary.listingsSummary.presentation.ratesUnitOfMeasure.averagePerNight'],
            perNight: translations['header.scratchpadSummary.listingsSummary.presentation.ratesUnitOfMeasure.perNight'],
            deleteText: translations['th.button.delete']
        };
    }
);

export {
    getTranslations,
    getHitTranslations
};



// WEBPACK FOOTER //
// ./src/universal/selectors/translations.js